export const iconFontAwesomeGamingWizardsOfTheCoast = (
	<i className="fa-solid fa-wizards-of-the-coast"></i>
);
